import { composeValidators, validate } from '@alfa-bank/site-helpers-form/validation/utils';
import { validateNotEmpty } from '@alfa-bank/site-helpers-form/validation/not-empty';
import { switchToKeyboard } from '@alfa-bank/site-helpers-common/browser/keyboard-switcher';

type TValidatorValue = string | undefined;

export const isValidPromoCode = (listOfPromoValues: string[], value?: string): boolean => {
    if (!value) return true;

    return listOfPromoValues.map(item => item.toUpperCase()).includes(value);
};

export const validatePromoCodeValue =
    (listOfPromoValues: string[], customMessage?: string) => (value: TValidatorValue) =>
        validate(
            isValidPromoCode(listOfPromoValues, value),
            'Вы ввели неверный промокод',
            customMessage
        );

export const validatePromoCode = (
    optional: boolean,
    listOfPromoValues: string[],
    message?: string
) => {
    const validators = [validatePromoCodeValue(listOfPromoValues, message)];

    if (!optional) {
        validators.push(validateNotEmpty());
    }

    return composeValidators(...validators);
};

export const formatPromoCode: (value: string, maxLength?: number) => string = (value, maxLength) =>
    switchToKeyboard(value, 'ru')
        .toUpperCase()
        .replace(/[^\dЁА-яё]/g, '')
        .substring(0, maxLength);
